import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'

import HomeView from '../views/HomeView.vue'
import AuthView from '../views/AuthView.vue'
import NewsView from '../views/news/NewsView.vue'
import NewsVersionViews from '../views/news/NewsVersionView.vue'
import NewsEditorView from '../views/news/NewsEditorView.vue'
import NewsEducationView from '../views/news/NewsEducationView.vue'
import NewsEditorEducationView from '../views/news/NewsEditorEducationView.vue'

import RolesView from '../views/roles/RolesView.vue'
import RolesEditorView from '../views/roles/RolesEditorView.vue'
import RolesVersionView from '../views/roles/RolesVersionView.vue'
import UserView from '../views/UserView.vue'
import ProductsView from '../views/products/ProductsView.vue'
import ProductsEditorView from '../views/products/ProductsEditorView.vue'
import ProductsVersionView from '../views/products/ProductsVersionView.vue'
import EngineeringEditorView from '../views/products/EngineeringEditorView.vue'
import EngineeringVersionView from '../views/products/EngineeringVersionView.vue'
import DevelopmentEditorView from '../views/products/DevelopmentEditorView.vue'
import DevelopmentVersionView from '../views/products/DevelopmentVersionView.vue'
import ModulesView from '../views/siteModules/ModulesView.vue'
import ModulesEducationView from '../views/siteEducationModules/ModulesEducationView'
import BannerEditorView from '../views/siteModules/BannerEditorView.vue'
import AchievementsEditorView from '../views/siteModules/AchievementsEditorView.vue'
import RegionsEditorView from '../views/siteModules/RegionsEditorView.vue'
import BannerEducationEditorView from '@/views/siteEducationModules/BannerEducationEditorView.vue'
import ActivityEditorView from '../views/siteModules/ActivityEditorView.vue'
import CooperationEditorView from '../views/siteModules/CooperationEditorView.vue'
import MediaEditorView from '../views/siteModules/MediaEditorView.vue'
import MaterialsEditorView from '../views/siteModules/MaterialsEditorView.vue'
import FooterEditorView from '../views/siteModules/FooterEditorView.vue'
import GroupLearningEditorView from '../views/siteEducationModules/GroupLearningEditorView.vue'
import GroupLearningEditorViewNew from '../views/siteEducationModules/GroupLearningEditorViewNew.vue'
import BasicInformationView from '../views/Information/BasicInformationView.vue'
import StructureView from '../views/Information/StructureView.vue'
import InternationalCooperationView from '../views/Information/InternationalCooperationView.vue'
import DocumentsView from '../views/Information/DocumentsView.vue'
import EducationView from '../views/Information/EducationView.vue'
import TeachersView from '../views/Information/TeachersView.vue'
import MaterialSupportView from '../views/Information/MaterialSupportView.vue'
import PaidServicesView from '../views/Information/PaidServicesView.vue'
import FInancialActivitiesView from '../views/Information/FInancialActivitiesView.vue'
import VacantPlaceView from '../views/Information/VacantPlaceView.vue'
import AccessibleEnvironmentView from '../views/Information/AccessibleEnvironmentView.vue'
import MaterialsEducationView from '../views/MaterialsEducationView.vue'
import ApplicationEducationView from '../views/ApplicationEducationView.vue'
import LearningGroupEditingPage from '../views/siteEducationModules/LearningGroupEditingPage.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/news/version/:id',
    name: 'compareNews',
    component: NewsVersionViews
  },
  {
    path: '/news/editor/:id',
    name: 'editorNews',
    component: NewsEditorView
  },
  {
    path: '/roles',
    name: 'roles',
    component: RolesView
  },
  {
    path: '/roles/:id',
    name: 'rolesEditor',
    component: RolesEditorView
  },
  {
    path: '/roles/version/:id',
    name: 'rolesVersion',
    component: RolesVersionView
  },
  {
    path: '/user',
    name: 'UserView',
    component: UserView
  },
  {
    path: '/products/:tabId',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/products/editor/:id',
    name: 'editorProducts',
    component: ProductsEditorView
  },
  {
    path: '/products/EngineeringEditor/:id',
    name: 'engineeringEditor',
    component: EngineeringEditorView
  },
  {
    path: '/products/DevelopmentEditor/:id',
    name: 'developmentEditor',
    component: DevelopmentEditorView
  },
  {
    path: '/products/version/:id',
    name: 'productsVersion',
    component: ProductsVersionView
  },
  {
    path: '/products/engineeringVersion/:id',
    name: 'engineeringVersion',
    component: EngineeringVersionView
  },
  {
    path: '/products/developmentVersion/:id',
    name: 'developmentVersion',
    component: DevelopmentVersionView
  },
  {
    path: '/modules',
    name: 'modules',
    component: ModulesView
  },
  {
    path: '/modules-education',
    name: 'modules-education',
    component: ModulesEducationView
  },
  {
    path: '/modules/editor/banner',
    name: 'editorBanner',
    component: BannerEditorView
  },
  {
    path: '/modules/editor/achievements',
    name: 'AchievementsEditorView',
    component: AchievementsEditorView
  },
  {
    path: '/modules/editor/regions',
    name: 'RegionsEditorView',
    component: RegionsEditorView
  },
  {
    path: '/modules-education/editor/banner-education',
    name: 'editorBannerEducation',
    component: BannerEducationEditorView
  },
  {
    path: '/modules/editor/activity',
    name: 'editorActivity',
    component: ActivityEditorView
  },
  {
    path: '/modules/editor/cooperation',
    name: 'editorCooperation',
    component: CooperationEditorView
  },
  {
    path: '/modules/editor/media',
    name: 'editorMedia',
    component: MediaEditorView
  },
  {
    path: '/modules/editor/materials',
    name: 'editorMaterials',
    component: MaterialsEditorView
  },
  {
    path: '/modules/editor/footer',
    name: 'editorFooter',
    component: FooterEditorView
  },
  {
    path: '/modules-education/editor/group-learning',
    name: 'groupLearning',
    component: GroupLearningEditorView
  },
  {
    path: '/modules-education/editor/group-learning-new',
    name: 'groupLearningNew',
    component: GroupLearningEditorViewNew
  },
  {
    path: '/news-education',
    name: 'news-education',
    component: NewsEducationView
  },
  {
    path: '/news-education/editor/:id',
    name: 'editorEducationNews',
    component: NewsEditorEducationView
  },
  {
    path: '/information/basic-information',
    name: 'basicInformation',
    component: BasicInformationView
  },
  {
    path: '/information/structure',
    name: 'structure',
    component: StructureView
  },
  {
    path: '/information/documents',
    name: 'documents',
    component: DocumentsView
  },
  {
    path: '/information/education',
    name: 'education',
    component: EducationView
  },
  {
    path: '/information/teachers',
    name: 'teachers',
    component: TeachersView
  },
  {
    path: '/information/material-support',
    name: 'materialSupport',
    component: MaterialSupportView
  },
  {
    path: '/information/paid-services',
    name: 'paidServices',
    component: PaidServicesView
  },
  {
    path: '/information/financial-activities',
    name: 'financialActivities',
    component: FInancialActivitiesView
  },
  {
    path: '/information/vacant-place',
    name: 'vacantPlace',
    component: VacantPlaceView
  },
  {
    path: '/information/accessible-environment',
    name: 'accessibleEnvironment',
    component: AccessibleEnvironmentView
  },
  {
    path: '/information/international-cooperation',
    name: 'internationalCooperation',
    component: InternationalCooperationView
  },
  {
    path: '/materials',
    name: 'Materials',
    component: MaterialsEducationView
  },
  {
    path: '/application',
    name: 'applicationEducationView',
    component: ApplicationEducationView
  },
  {
    path: '/LearningGroupEditingPage/:id',
    name: 'LearningGroupEditingPage',
    component: LearningGroupEditingPage
  }
  // {
  //   path: '/products/version/:id',
  //   name: 'compareProducts',
  //   component: ProductsVersionViews
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const tokenValue = localStorage.token || sessionStorage.token

  store.commit('SetBigPreloader', true)
  if (tokenValue === undefined && to.path !== '/auth') {
    next('/auth')
    return
  } else if (tokenValue !== undefined && to.path === '/auth') {
    next(from.path)
    return
  }
  next()
})

router.afterEach(() => {
  setTimeout(() => {
    store.commit('SetBigPreloader', false)
  }, 1000)
})

export default router
